export const DEFAULT_TIME = '12:00am';
export const COMPARE_GRANULARITY = 'minute';
